<template>
  <div class="container">
    <div class="to-top" @click="scrollToTop">
      回到顶部
    </div>
    <div class="header">
      <div class="w1250">
        <z-header></z-header>
      </div>
    </div>
    <div class="main w1200">
      <div>
        <span class="f-weight ad_tit">帮助中心</span>
        <span class="update-time">更新时间：2019-10-28</span>
      </div>
      <span class="f-weight">常见问题</span>
      <el-card class="box-card">
        <div class="question-item"><a href="#1">资质中心上传资质时，行业参考信息如何获取？</a></div>
        <div class="question-item"><a href="#2">资质中心已有的行业资质能否修改？如果修改会影响什么？</a></div>
        <div class="question-item"><a href="#3">资质到期前是否有相关提醒？</a></div>
        <div class="question-item"><a href="#4">如何修改行业资质？</a></div>
        <div class="question-item"><a href="#5">什么是账户主体资质？与行业资质有何不同？</a></div>
        <div class="question-item"><a href="#6">如何上传及修改账户主体资质？</a></div>
        <div class="question-item"><a href="#7">主体资质变更对在投广告有何影响？</a></div>
        <div class="question-item"><a href="#8">个人类广告主行业有何限制？</a></div>
      </el-card>
      <span class="f-weight">问题解答</span>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span id="1">资质中心上传资质时，行业参考信息如何获取？</span>
        </div>
        <p>行业对账户类型、认证的要求、对账户主体资质的要求、某客户属于什么行业等。</p>
        <p>请联系微博客服。</p>
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span id="2">资质中心已有的行业资质能否修改？如果修改会影响什么？</span>
        </div>
        <el-table style="width:900px" :data="question2Data" :span-method="objectSpanMethod2" header-row-class-name="header-row" border>
          <el-table-column prop="status" label="存量资质状态" width="200"></el-table-column>
          <el-table-column prop="allowModify" label="是否允许修改"></el-table-column>
          <el-table-column prop="effect" label="对创意的影响"></el-table-column>
        </el-table>
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span id="3">资质到期前是否有相关提醒？</span>
        </div>
        <p>针对资质中心审核通过的有效状态的资质，系统将会根据客户提交的资质有效期，在其过期前<span class="strong">30天</span>持续对客户进行提示，直至客户修改并审核通过。</p>
        <p>提醒信息显示在两处：</p>
        <h3 style="margin:18px 0">(1)资质中心到期提醒</h3>
        <p style="text-indent:20px">在资质中心的资质列表中，到期前30天的有效资质，可在右侧操作区看到“修改”按钮，点击按钮，进入资质的详情页面，查看资质情况，并进行修改。</p>
        <p style="text-indent:20px">如下图红框所示：</p>
        <img style="margin-left:20px" src="../assets/question3-1.png" width="800" />
        <p style="text-indent:20px">鼠标移入图标，会显示“点击进行修改”，客户可按此提示操作</p>
        <p style="text-indent:20px">如下图所示：</p>
        <img style="margin-left:20px" src="../assets/question3-2.png" width="800" />
        <p style="text-indent:20px">进入资质详情页，资质包中即将过期的资质右侧，会展示提示信息“资质即将到期，请修改”</p>
        <p style="text-indent:20px">如下图所示：</p>
        <img style="margin-left:20px" src="../assets/question3-3.png" width="800" />
        <p style="text-indent:20px">点击资质详情页右上角的“立即修改”按钮，可以进入资质编辑页面，修改信息并提交。</p>
        <p style="text-indent:20px">如下图所示：</p>
        <img style="margin-left:20px" src="../assets/question3-4.png" width="800" />
        <h3 style="margin:10px 0">(2)超粉站内信提醒</h3>
        <p style="text-indent:20px">除资质中心页面上的提醒，客户的超粉平台站内信信箱中，也会收到相关到期提醒私信。</p>
        <p style="text-indent:20px">查看位置如下图所示：</p>
        <img style="margin-left:20px" src="../assets/question3-5.png" width="800" />
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span id="4">如何修改行业资质？</span>
        </div>
        <p>根据资质所属行业性质的不同，有一部分特殊行业修改功能有所限制，详见下面说明</p>
        <h2 style="margin:18px 0">(1)即将到期的废弃行业资质</h2>
        <ul style="margin-left:30px">
            <li><p>由于资质行业体系的调整， 原行业体系内的部分行业已经废弃，废弃行业a.不能新增资质，b.且其存量资质不能关联新的创意。</p></li>
            <li><p class="strong">针对这些废弃行业的存量有效资质，采取到期前提醒但不可修改、只能重新上传的处理流程。</p></li>
            <li><p>客户要特别注意，处理这类资质时，要及时按新行业体系重新上传新的资质，并将创意关联到新资质，重新送审。</p></li>
            <li><p>这类行业资质到期后，其关联的创意会自动下线。</p></li>
        </ul>
        <p style="text-indent:20px">如下图显示，这类资质在到期前，状态栏会显示红色叹号，鼠标移入会展示“该资质包对应资质行业有调整，不提供修改该功能，且不允许关联新创意”。点击进入查看资质详情，页面也会展示相应提示。</p>
        <img style="margin-left:20px" src="../assets/question4-1.png" width="800"/>
        <img style="margin-left:20px" src="../assets/question4-2.png" width="800"/>
        <img style="margin-left:20px" src="../assets/question4-3.png" width="800"/>
        <h2 style="margin:18px 0">(2)针对“驳回”、“过期”状态的废弃行业资质修改</h2>
        <p style="text-indent:20px">由于行业体系调整的影响，原行业体系内的部分行业已经废弃，对此类行业，其存量资质中状态为“驳回”、“过期”的资质信息，修改功能也会受限，详细说明如下：</p>
        <h3 style="margin:18px 20px">1)过期</h3>
        <p style="text-indent:40px">一般行业的“过期”资质，是允许修改的。</p>
        <p style="text-indent:40px">但废弃行业的存量资质如果“过期”，不允许修改。客户可以按新的行业体系重新上传相关资质备案。</p>
        <p style="text-indent:40px">【示例】</p>
        <p style="text-indent:40px">下图：资质列表中，展示“过期”状态的资质，点击右侧操作区的“查看”按钮，进入资质详情页，查看能否修改。</p>
        <img style="margin-left:40px" src="../assets/question4-4.png" width="800" />
        <p style="text-indent:40px">下图：一般行业资质，如过期，在资质详情页点击右上角“立即修改”，进行修改并重新送审备案。</p>
        <img style="margin-left:40px" src="../assets/question4-5.png" width="800" />
        <p style="text-indent:40px">下图：废弃行业的存量资质过期，点击查看详情，不允许修改。可以点击右上角“添加资质”按钮，按新的行业体系上传资质并送审备案。</p>
        <img style="margin-left:40px" src="../assets/question4-6.png" width="800" />
        <h3 style="margin:18px 20px">2)驳回</h3>
        <p style="text-indent:40px">一般行业的“驳回”资质，是允许修改的。</p>
        <p style="text-indent:40px">废弃行业存量资质为“驳回”，不允许修改。客户可以按新的行业体系重新上传相关资质备案。</p>
        <p style="text-indent:40px">【示例】</p>
        <p style="text-indent:40px">下图：资质列表中，展示“驳回”状态的资质，点击右侧操作区的“查看”按钮，进入资质详情页，查看能否修改。</p>
        <img style="margin-left:40px" src="../assets/question4-7.png" width="800" />
        <p style="text-indent:40px">下图：一般行业资质，如被驳回，在资质详情页点击右上角“立即修改”，进行修改并重新送审备案</p>
        <img style="margin-left:40px" src="../assets/question4-8.png" width="800" />
        <p style="text-indent:40px">下图：废弃行业的存量资质是驳回状态，点击查看详情，不允许修改。可以点击右上角“添加资质”按钮，按新的行业体系上传资质并送审备案。</p>
        <img style="margin-left:40px" src="../assets/question4-9.png" width="800" />
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span id="5">什么是账户主体资质？与行业资质有何不同？</span>
        </div>
        <h3 style="margin:18px 0">(1)账户主体资质的定义</h3>
        <p style="text-indent:20px">用于识别账户（UID）的主体信息，一个账户有且仅有1个有效主体资质。</p>
        <p style="text-indent:20px">当前所有主体资质类型如下：</p>
        <el-table style="width:600px;margin-left:18px" :data="question5Data" :span-method="objectSpanMethod5" header-row-class-name="header-row" border stripe>
          <el-table-column prop="advertiserType" label="广告主类型" width="150"></el-table-column>
          <el-table-column prop="qualificationType" label="主体资质类型"></el-table-column>
        </el-table>
        <h3 style="margin:18px 0">(2)账户主体资质特点</h3>
        <p style="text-indent:20px">主体资质模块为单独提出，只需上传1次，无需重复上传。</p>
        <p style="text-indent:20px">同一账户有且仅有1个有效主体资质，所有行业资质都与这个主体资质关联，不允许同一账户下多个投放主体。</p>
        <h3 style="margin:18px 0">(3)资质中心将分为“主体资质“、”行业资质“两个模块</h3>
        <p style="text-indent:20px">如图所示：</p>
        <img style="margin-left:20px" src="../assets/question5-1.png" width="800" />
        <p style="text-indent:20px">其中“主体资质“模块，展示当前账户（UID）下的主体资质信息，可在此查看、上传、修改主体资质</p>
        <p style="text-indent:20px">其中“行业资质“模块，展示当前账户（UID）下的行业及补充资质信息，可在此查看、上传、修改行业及补充资质。</p>
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span id="6">如何上传及修改账户主体资质？</span>
        </div>
        <h3>(1)账户已在聚财开户</h3>
        <p style="text-indent:20px">入口1：聚财（掘金）账户管理页面</p>
        <img style="margin-left:20px" src="../assets/question6-1.png" width="800" />
        <img style="margin-left:20px" src="../assets/question6-2.png" width="800" />
        <p style="text-align:center">（将可选择对应的主体类型）</p>
        <p style="text-indent:20px">入口2：资质中心“主体资质“模块</p>
        <img style="margin-left:20px" src="../assets/question6-3.png" width="800" />
        <h3>(2)账户未在聚财开户</h3>
        <p style="text-indent:20px">入口1：资质中心“主体资质“模块</p>
        <img style="margin-left:20px" src="../assets/question6-4.png" width="800" />
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span id="7">主体资质变更对在投广告有何影响？</span>
        </div>
        <p>变更账户主体资质可能对在投广告产生影响，因此变更请务必慎重。说明如下：</p>
        <el-table style="width:1000px" :data="question7Data" header-row-class-name="header-row" :span-method="objectSpanMethod7" border stripe>
          <el-table-column prop="isModify" label="主体资质是否变更" width="210"></el-table-column>
          <el-table-column prop="desc" label="说明"></el-table-column>
          <el-table-column prop="mainQualStatus" label="主体资质状态" width="200"></el-table-column>
          <el-table-column prop="industryQual" label="行业资质包"></el-table-column>
        </el-table>
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span id="8">个人类广告主行业有何限制？</span>
        </div>
        <p>个人类开户广告主在资质中心上传行业资质时，仅限上传以下行业的资质，其他行业不可见，不符合规范的账户要及时更新主体类型：</p>
        <el-table style="width:400px;" :data="question8Data" header-row-class-name="header-row" border stripe>
          <el-table-column prop="industry" label="一级行业" width="150"></el-table-column>
          <el-table-column prop="subindustry" label="二级行业"></el-table-column>
        </el-table>
      </el-card>
    </div>
  </div>
</template>
<script>

export default {
  name: 'Help',
  components: {},
  data: function () {
    return {
      question2Data: [{
        status: '有效',
        allowModify: '不允许修改',
        effect: '关联广告创意不受影响'
      }, {
        status: '驳回',
        allowModify: '如果存量资质包的行业在新行业体系中仍然沿用，则资质包信息可以修改，页面会看到“修改按钮”点击修改并提交后，重新送审核',
        effect: '无关联创意'
      }, {
        status: '驳回',
        allowModify: '如果存量资质包的行业已经在新行业体系中删除，则资质包信息只展示，不能修改，页面会看到“添加资质”按钮，需要点击“添加资质”，按新行业提交信息，并送审',
        effect: '无关联创意'
      }, {
        status: '过期',
        allowModify: '如果存量资质包的行业在新行业体系中仍然沿用，则资质包信息可以修改，页面会看到“修改按钮”点击修改并提交后，重新送审核',
        effect: '未关联创意，则无影响。已关联创意，资质包过期期间创意会下线。资质包重新审核通过后才会恢复正常。'
      }, {
        status: '过期',
        allowModify: '如果存量资质包的行业已经在新行业体系中删除，则资质包信息只展示，不能修改，页面会看到“添加资质”按钮，需要点击“添加资质”，按新行业提交信息，并送审',
        effect: '未关联创意，则无影响。已关联创意，则资质包过期期间创意会下线，且创意送审需要关联新的资质包，重新送审'
      }],
      question5Data: [{
        advertiserType: '企业类',
        qualificationType: '企业营业执照'
      }, {
        advertiserType: '企业类',
        qualificationType: '事业单位法人证书'
      }, {
        advertiserType: '企业类',
        qualificationType: '组织机构代码证'
      }, {
        advertiserType: '企业类',
        qualificationType: '公证机构执业证'
      }, {
        advertiserType: '企业类',
        qualificationType: '基金会法人登记证书'
      }, {
        advertiserType: '企业类',
        qualificationType: '律师事务所执业许可证'
      }, {
        advertiserType: '企业类',
        qualificationType: '社会团体法人登记证书'
      }, {
        advertiserType: '企业类',
        qualificationType: '司法鉴定机构执业许可证'
      }, {
        advertiserType: '企业类',
        qualificationType: '外国律师事务所驻华代表处执业许可证'
      }, {
        advertiserType: '企业类',
        qualificationType: '海外主体资质证明（当地的主体注册资质证明及翻译件）'
      }, {
        advertiserType: '个人类',
        qualificationType: '个人身份证'
      }],
      question7Data: [{
        isModify: '未变更：主体资质由A变为A’',
        desc: '企业类：仅修改有效期、图片',
        mainQualStatus: 'A变为失效，A’变为有效',
        industryQual: '与A绑定的所有行业资质包中，关联的主体资质由A替换为A’,行业资质包状态、广告创意状态不受影响'
      }, {
        isModify: '未变更：主体资质由A变为A’',
        desc: '个人类：仅修改有效期、图片',
        mainQualStatus: 'A变为失效，A’变为有效',
        industryQual: '与A绑定的所有行业资质包中，关联的主体资质由A替换为A’,行业资质包状态、广告创意状态不受影响'
      }, {
        isModify: '变更：主体资质由A变为B',
        desc: '资质类型发生变化：1.个人类变为企业类，2.企业类变为个人类，3.企业类中不同类型主体资质切换',
        mainQualStatus: 'A变为失效，B变为有效',
        industryQual: '与A绑定的所有行业资质包：关联主体不替换，行业资质包全部变为无效，与其关联的广告创意下线'
      }, {
        isModify: '变更：主体资质由A变为B',
        desc: '企业类：投放主体发生变更（主体资质名称、编号变化）',
        mainQualStatus: 'A变为失效，B变为有效',
        industryQual: '与A绑定的所有行业资质包：关联主体不替换，行业资质包全部变为无效，与其关联的广告创意下线'
      }, {
        isModify: '变更：主体资质由A变为B',
        desc: '个人类：身份证姓名或号码发生变化',
        mainQualStatus: 'A变为失效，B变为有效',
        industryQual: '与A绑定的所有行业资质包：关联主体不替换，行业资质包全部变为无效，与其关联的广告创意下线'
      }],
      question8Data: [{
        industry: '医疗机构',
        subindustry: '医生科普'
      }, {
        industry: '情感咨询',
        subindustry: '情感咨询（个人类）'
      }, {
        industry: '教育培训',
        subindustry: '学校教师（个人类）'
      }, {
        industry: '律师事务所',
        subindustry: '律师'
      }, {
        industry: '个人分享',
        subindustry: '个人分享'
      }]
    }
  },
  methods: {
    objectSpanMethod2 ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex === 0) {
          return [1, 1]
        } else if (rowIndex % 2 !== 0) {
          return [2, 1]
        } else {
          return [0, 0]
        }
      }
    },
    objectSpanMethod5 ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex === 0) {
          return [10, 1]
        } else if (rowIndex === 10) {
          return [1, 1]
        } else {
          return [0, 0]
        }
      }
    },
    objectSpanMethod7 ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 2 || columnIndex === 3) {
        if (rowIndex === 0) {
          return [2, 1]
        } else if (rowIndex === 2) {
          return [3, 1]
        } else {
          return [0, 0]
        }
      }
    },
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}

</script>
<style>
  .to-top{
    position: fixed;
    right: 20px;
    bottom: 100px;
    width: 60px;
    height: 60px;
    border-radius: 60px;
    text-align: center;
    line-height: 60px;
    background-color: #000000;
    color: #ffffff;
    cursor: pointer;
  }
  .f-weight{
    font-family: PingFangSC-Medium;
    font-size: 18px;
    color: #2E334A;
    letter-spacing: 0.83px;
    text-align: center;
    line-height: 18px;
  }
  .ad_tit {
    width: 148px;
    font-size: 18px;
    color: #2E334A;
    font-weight: bold;
    height: 66px;
    line-height: 66px;
  }
  .update-time{
    margin-left: 10px;
    font-size: 12px;
    color: red;
    font-weight: bold;
  }
  .box-card{
      margin: 18px 0;
  }
  .box-card .el-card__header{
    padding: 15px 20px;
    font-size: 18px;
  }
  .box-card p{
      font-size: 14px;
      line-height: 28px;
  }
  .box-card img{
      margin: 10px 0;
  }
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }
  .question-item{
      line-height: 28px;
      font-size: 14px;
  }
  .header-row > th {
    background: #ebf0fb;
  }
  .strong{
      color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/Help.vue